import * as React from 'react';
import Image from '../_common/image';
import SectionTitle from '../_common/section-title';
import { ReactComponent as ZoomIcon } from '../../assets/svg/icons/zoom.svg';
import { getText, getConfig } from '../../helpers';
import './dataset-image-section.style.scss';

const Carousel = React.lazy(() => import('../_common/carousel'));

const title = getText('generic.graphTitle');
const options = getConfig('routes.dataset.carouselOptions');
const bundleOptions = { ...options, lazyLoad: false };
const initialCarouselState = getConfig('routes.dataset.initialCarouselState');

const datasetImageSection = function DatasetImageSection({ dataset, isBundle }: DatasetImageSectionProps) {
    const linkedDatasets = dataset.bundleDatasets || [];

    const [carouselState, updateCarouselState] = React.useState<{ activeSlide: number; totalSlides: number }>(initialCarouselState);

    React.useEffect(() => {
        updateCarouselState({
            activeSlide: 1,
            totalSlides: linkedDatasets.filter((linkedDataset: DataProfile) => linkedDataset.overviewImageFilePath !== null).length
        });
    }, [dataset]);

    const carouselOptions = {
        ...bundleOptions,
        adaptiveHeight: false,
        beforeChange: (active: number, next: number) => {
            updateCarouselState(state => {
                return { ...state, activeSlide: next + 1 };
            });
        }
    };

    const bundleCarouselImage = (
        <>
            {carouselState.totalSlides > 0 && (
                <>
                    <div data-testid="bundle-carousel-image" className="page-section__inner">
                        <SectionTitle text={title} subText={<span>{`${carouselState.activeSlide} of ${carouselState.totalSlides}`}</span>} />
                    </div>
                    <Carousel carouselSettings={carouselOptions}>
                        {linkedDatasets
                            .filter((linkedDataset: DataProfile) => linkedDataset.overviewImageFilePath !== null)
                            .map((linkedDataset: DataProfile) => (
                                <div key={linkedDataset.name} className="page-section__inner">
                                    <h2 className="h4">{linkedDataset.name}</h2>
                                    <div className="dataset-overview-section__chart dataset-overview-section__chart-bundle">
                                        <Image src={linkedDataset.overviewImageFilePath} alt="" className="dataset-overview-section__image" />
                                        <ZoomIcon className="dataset-overview-section__zoom-icon" />
                                    </div>
                                </div>
                            ))}
                    </Carousel>
                    <hr />
                </>
            )}
        </>
    );

    const noBundleImage = dataset.overviewImageFilePath && (
        <div className="dataset-overview-section">
            <div className="page-section__inner">
                <div className="dataset-overview-section__chart dataset-overview-section__chart-bundle">
                    <Image src={dataset.overviewImageFilePath} alt="" className="dataset-overview-section__image" />
                    <ZoomIcon className="dataset-overview-section__zoom-icon" />
                </div>
            </div>
            <hr />
        </div>
    );
    return <div className="dataset-overview-section__chartBreak">{isBundle ? bundleCarouselImage : noBundleImage}</div>;
};

export default React.memo(datasetImageSection);
